/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// var stockcnt = document.getElementById('stockcount').innerHTML;
// if (stockcnt==1){
//  document.getElementById('stock').InnerHTML="Out of Stock";
// }else{
// document.getElementById('stock').InnerHTML="In Stock";
// }
// $(document).ready(function(){
//   var href = (window.location.href);
//    if(window.location.href.indexOf("?variant=") > -1) {
//       href = href.split("=");
//      href = href[1];
     
//     }
//   else{
   
//   }
// }) 

$(document).ready(function(){
      
  $(document).mouseup(function (e){

      var container = $("#headr-search");

      if (!container.is(e.target) && container.has(e.target).length === 0){

          container.fadeOut();

      }
  }); 
   
  
  $(".Header__SecondaryNav .HorizontalList__Item").on("mouseleave", function() {
       $(this).removeClass("is-expanded");  //or $('.overlay').hide()
       //$(".Header__SecondaryNav .HorizontalList__Item:first-child .DropdownMenu").hide();
       $(".Header__SecondaryNav .HorizontalList__Item .DropdownMenu").attr('aria-hidden', true);
  });
  
}); 

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


(function(){

  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;
  var ww = w.innerWidth;
  

  var header = document.getElementById('site-header');
  var main = document.getElementById('main');
  var hheight = header.offsetHeight;
  
  main.style.marginTop = hheight + 'px';

  var checkScroll = debounce(function() {

    /*
    ** Find the direction of scroll
    ** 0 - initial, 1 - up, 2 - down
    */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) { 
      //scrolled up
      direction = 2;
    }
    else if (curScroll < prevScroll) { 
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }
    
    
    
    if ($(w).scrollTop() > 80) {
        header.classList.add('hidetop');
    } else {
        header.classList.remove('hidetop');
    }
    
    prevScroll = curScroll;
  }, 10);

  var toggleHeader = function(direction, curScroll) {
    
    
    if(ww < 810) {
    
      if (direction === 2 && curScroll > 80) { 

        //replace 52 with the height of your header in px

          header.classList.add('hide');
          prevDirection = direction;


      }
      else if (direction === 1) {
        header.classList.remove('hide');
        prevDirection = direction;
      }
      
    }
  };
  
  window.addEventListener('scroll', checkScroll);
  
  

})();


